<template>
	<ja-modal v-if="event" ref="modal" :show="show">
		<content class="life-event-modal">
			<div class="inner-avatar">
				<img :src="require(`@/assets/images/Jimmy.png`)" alt="" />
			</div>
			<div v-if="userData">
				<h1>
					{{ $t('hey') }}
					{{ lifeStageData.formStudentName ?? userData.firstName }},
				</h1>
			</div>
			<div class="body-text-1 balance-info">
				{{ event.description }}
			</div>

			<!-- Choice of account -->
			<div
				v-if="
					event.cmsLifeEventAccountType.length > 1 ||
						(event.cmsLifeEventAccountType.length > 1 &&
							event.mustChooseAccount == true)
				"
				class="choice-of-account"
			>
				<div
					v-for="(type, index) in event.cmsLifeEventAccountType"
					:key="index"
					class="option-container"
				>
					<ja-button
						:name="
							`${
								type.cmsAccountType.name === 'Checking' && JA_LOCALIZATION_IRL
									? $t('debit')
									: type.cmsAccountType.name
							}`
						"
						:value="type.cmsAccountType.accountType_ID"
						:selected="selectedAccount == type.cmsAccountType.accountType_ID"
						:disabled="
							!event.isAmountAdded &&
								isThereEnoughMoney(type.cmsAccountType.name)
						"
						class="small transparent link-button"
						@click.native="selectAccount"
						>{{
							choiceOfAccountVerb +
								`${
									type.cmsAccountType.name === 'Checking' && JA_LOCALIZATION_IRL
										? $t('debit')
										: type.cmsAccountType.name
								}`
						}}</ja-button
					>
				</div>
			</div>

			<!-- No choice -->
			<ja-button
				v-if="event.mustChooseAccount == null"
				class="link-button small transparent"
				name="close-life-event"
				@click.native="submitEvent"
				>{{ $t('okay') }}</ja-button
			>

			<!-- Choice of doing nothing -->
			<div v-if="event.mustChooseAccount == false" class="button-wrapper">
				<ja-button
					class="link-button small transparent"
					name="false"
					:value="false"
					@click.native="chooseToDo(false)"
				>
					<span>{{ $t('no') }}</span>
				</ja-button>
				<div>{{ $t('or') }}</div>
				<ja-button
					class="link-button small transparent"
					name="true"
					:value="true"
					@click.native="chooseToDo(true)"
				>
					<span>{{ $t('yes') }}</span>
				</ja-button>
			</div>

			<div class="wrapper-current-balance">
				<div
					v-for="(type, index) in event.cmsLifeEventAccountType"
					:key="index"
					class="current-balance"
				>
					{{
						`${
							type.cmsAccountType.name === 'Checking' && JA_LOCALIZATION_IRL
								? $t('debit')
								: type.cmsAccountType.name
						} ${$t('account')}: ${$t('currencySymbol')}${currentBalance(
							type.cmsAccountType.name
						)}`
					}}
				</div>
			</div>
		</content>
	</ja-modal>
</template>
<script>
import '../icons/thats-life';
import LifeStageData from '../../mixins/LifeStageData';
import ProfileData from '../../mixins/ProfileData';
import ModalEvents from '../../mixins/ModalEvents';
import Modal from './Modal';
import Button from '../ui/Button';
import UserData from '../../mixins/UserData';
import gql from 'graphql-tag';
import { defaultNames } from '../../helpers/constants';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button
	},
	mixins: [LifeStageData, UserData, ProfileData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		},
		event: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			amount: '',
			selectedAccount: 1,
			choseToDoNothng: null,
			JA_LOCALIZATION_IRL: this.$store.getters.isIrl
		};
	},
	computed: {
		generalSavingsBalance() {
			if (this.lifeStageData.studentGoals) {
				var savings = this.lifeStageData.studentGoals.filter(
					x => x.goal_Id === null
				)[0].totalSavingsAmount;

				return savings;
			}
			return null;
		},
		choiceOfAccountVerb() {
			let verb = this.event.isAmountAdded
				? this.$t('addTo')
				: this.$t('payWith');
			verb += ' ';

			return verb;
		}
	},
	methods: {
		currentBalance(account) {
			let checkingAccountBalance = this.netMonthlyIncome;
			let savingsAccountBalance = this.generalSavingsBalance;
			let creditAccountBalance = this.lifeStageData.creditCardDebt;

			let totalExpenses = this.lifeStageData.totalExpenses;
			let afterExpencesAmount;

			if (
				account === this.$t('checking') ||
				account.toLowerCase() === defaultNames.CHECKING
			) {
				afterExpencesAmount = checkingAccountBalance - totalExpenses;
				return this.checkIfGreaterThanZero(afterExpencesAmount);
			} else if (
				account === this.$t('savings') ||
				account.toLowerCase() === defaultNames.SAVINGS
			) {
				return this.checkIfGreaterThanZero(savingsAccountBalance);
			} else if (
				account === this.$t('credit') ||
				account.toLowerCase() === defaultNames.CREDIT
			) {
				afterExpencesAmount = creditAccountBalance - totalExpenses;
				return this.checkIfGreaterThanZero(afterExpencesAmount);
			}
		},
		checkIfGreaterThanZero(afterExpencesAmount) {
			if (afterExpencesAmount > 0) {
				return afterExpencesAmount.toLocaleString('en-US');
			}
			return 0;
		},
		chooseToDo(choice) {
			this.choseToDoNothng = choice;
			this.submitEvent();
		},

		isThereEnoughMoney(typename) {
			let accAmount;
			if (typename === 'Savings') {
				accAmount = this.generalSavingsBalance;
				let eventAmount = this.event.amount;
				return accAmount < eventAmount;
			}

			accAmount =
				this.lifeStageData[this.getAccountNameInDB(typename)] -
				this.lifeStageData.totalExpenses;
			let eventAmount = this.event.amount;
			return accAmount < eventAmount;
		},
		getAccountNameInDB(account) {
			if (account === 'Checking') {
				return 'netMonthlyIncome';
			} else if (account === 'Credit') {
				return 'creditCardDebt';
			}
			return this.generalSavingsBalance;
		},
		selectAccount() {
			this.selectedAccount = event.target.value;
			if (this.event.mustChooseAccount == true) {
				this.submitEvent();
			}
		},

		closeModal() {
			localStorage.removeItem('lifeEvent');
			this.$emit('closeModal');
		},

		async submitEvent() {
			const studentLifeEvent = {
				studentId: this.userData.studentId,
				choseToDoNothing: this.choseToDoNothng,
				accountType_ID: parseInt(this.selectedAccount),
				lifeEvent_ID: this.event.lifeEvent_ID,
				lifeStage_ID: this.lifeStageData.lifeStage_ID
			};

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($add: StudentLifeEventAddInputObjectGraphType!) {
						addStudentLifeEvent(add: $add) {
							id
						}
					}
				`,
				variables: {
					add: studentLifeEvent
				}
			});
			if (response.data) {
				this.closeModal();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.life-event-modal {
	padding: 64px 70px;

	h1 {
		margin: 0;
	}

	h5 {
		margin: 8px 0;
	}

	.inner-avatar {
		position: relative;
		top: -125px;
		margin-bottom: -120px;
		background-color: #ffffff;
		border-radius: 50%;
		border: 4px solid #e7f8ff;
		width: 110px;
		height: 110px;

		img {
			width: 75px;
		}
	}
	.balance-info {
		width: 100%;
		padding: 32px 0;
	}
	.choice-of-account {
		display: flex;
	}
	.button-wrapper {
		display: flex;
		margin: auto;
		justify-content: space-around;
		min-width: 100px;
		margin: auto;
		align-items: center;
	}

	.checking-info {
		display: flex;
		flex-basis: 50%;
		margin-top: 16px;
		color: $font-gray;

		div {
			flex-basis: 50%;
			text-align: right;
			&:first-child {
				text-align: left;
			}
		}
	}
	.wrapper-current-balance {
		height: 40px;
		width: 362px;
		color: #687682;
		font-family: 'RobotoRegular';
		font-size: 14px;
		line-height: 20px;
		text-align: center;
		margin-top: 16px;
		text-transform: capitalize;
		@media (min-width: $breakpoint-mid) {
			font-size: 18px;
		}
		.current-balance {
			max-width: 360px;
			display: flex;
			justify-content: center;
			margin: 5px;
		}
	}
}
</style>
